import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Payment } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { fetchCaissierTerminal } from '../../services/posService';
import CashierSidebar from '../../components/cashier/CashierSidebar';
import CashierHeader from '../../components/cashier/CashierHeader';
import ClientsDirectory from '../../components/clients/ClientsDirectory';
import PaymentChoiceModal from './PaymentChoiceModal';

/** Clients côté caissier : même annuaire que l'admin, activité limitée à ses propres encaissements. */
const CashierCustomersPage = () => {
    const { selectedOrganization, organizations, user } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [caissierTerminal, setCaissierTerminal] = useState(null);
    const [paymentChoiceCustomer, setPaymentChoiceCustomer] = useState(null);

    useEffect(() => {
        if (!selectedOrganization?.id || !user?.id) return;
        fetchCaissierTerminal(selectedOrganization.id, user.id)
            .then((terminal) => setCaissierTerminal(terminal || null))
            .catch(() => setCaissierTerminal(null));
    }, [selectedOrganization?.id, user?.id]);

    const handleChooseDemande = (customer) => {
        navigate('/cashier/payment-requests', { state: { customer } });
        setPaymentChoiceCustomer(null);
    };
    const handleChooseLien = (customer) => {
        navigate('/cashier/payment-links', { state: { customer } });
        setPaymentChoiceCustomer(null);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-amber-50/20 to-slate-50 flex">
            <CashierSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

            <div className="flex-1 min-h-screen transition-all duration-300 overflow-hidden flex flex-col lg:ml-[var(--cashier-sidebar-w,18rem)] transition-[margin] duration-300">
                <CashierHeader onMenuToggle={() => setSidebarOpen(!sidebarOpen)} terminal={caissierTerminal} />

                <div className="flex-1 p-5 lg:p-8 overflow-y-auto">
                    <ClientsDirectory
                        selectedOrganization={selectedOrganization}
                        organizations={organizations}
                        emitterId={user?.id}
                        canDelete={false}
                        subtitle="Vos clients et les paiements que vous avez encaissés, un client par numéro de téléphone."
                        renderClientActions={(client, close) => (
                            <button
                                type="button"
                                onClick={() => { close(); setPaymentChoiceCustomer(client); }}
                                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 font-semibold text-white hover:bg-emerald-700"
                            >
                                <Payment fontSize="small" /> Encaisser
                            </button>
                        )}
                    />
                </div>
            </div>

            <PaymentChoiceModal
                show={!!paymentChoiceCustomer}
                onClose={() => setPaymentChoiceCustomer(null)}
                customer={paymentChoiceCustomer}
                onChooseDemande={handleChooseDemande}
                onChooseLien={handleChooseLien}
            />
        </div>
    );
};

export default CashierCustomersPage;
